export function Switch({ success, error, children }) {
  if (error) return error
  if (success) return success
  return children || null
}
